import axios from "axios";
import Links from "../constants/Links";


const resultHistory = {
    resultHistoryMigrationStats: async () => {
        return axios.get(Links.resultHistory.resultHistoryMigrationStats)
    },

    resultFilter: async (data) => {
        return axios.get(Links.resultHistory.resultFilter, {
            params: data
        })
    }, 

    enforceManualMigration: async (data) => {
        return axios.post(Links.resultHistory.manualMigration, data)
    }, 

    forceReCreateMigration: async (data) => {
        return axios.post(Links.resultHistory.forceMigration, data)
    }
}; 


export default resultHistory;